import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ProfileCompletionBanner = () => {
  const [isProfileComplete, setIsProfileComplete] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const profileComplete = localStorage.getItem("profileComplete");
    setIsProfileComplete(profileComplete === "true");
  }, []);

  if (isProfileComplete || isDismissed) {
    return null;
  }

  return (
    <div className="w-full bg-yellow-50 border-b border-yellow-200 text-yellow-800 px-2 md:px-6 py-3 flex items-center justify-between shadow-sm">
      {/* Left: Icon + Message */}
      <div className="flex items-center space-x-3">
        {/* Incomplete / Warning Icon */}
        <span className="hidden md:inline text-yellow-600 text-xl">⚠️</span>
        <p className="text-xs md:text-sm">
          Your profile is incomplete. Complete your profile to get the best experience.
        </p>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center space-x-4">
        <Link
          to="/profile"
          className="text-sm font-semibold text-yellow-700 hover:underline hidden md:inline-block"
        >
          Go to Profile
        </Link>
        <button
          onClick={() => setIsDismissed(true)}
          className="text-yellow-500 hover:text-yellow-700 text-lg leading-none"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ProfileCompletionBanner;
